import {call, select} from "redux-saga/effects";
import {GDPR} from "../state/gdpr";
import {AppState} from "../state";
import {gdpr} from "./gdpr";

export function *triton() {
    const triton:number =  yield select((appState: AppState) => (appState.input?.triton));
    if (!triton) {
        return {
            triton,
            gdpr: null
        };
    }
    const hasGdrp:GDPR =  yield call(gdpr);
    yield call(() => {
        return new Promise<void>((rej) => {
            const timeout = setTimeout(() => {
                rej();
            }, 2000);
            const script = document.createElement('script');
            document.body.appendChild(script);
            script.onload = () => {
                clearTimeout(timeout);
                rej();
            };
            script.onerror = () => {
                clearTimeout(timeout);
                rej();
            };

            script.async = true;
            if (hasGdrp) {
                script.src = `https://playerservices.live.streamtheworld.com/api/idsync.js?stationId=${triton}&gdpr_consent=${hasGdrp.tcString}&gdpr=${hasGdrp.gdprApplies ? 1 : 0}`
            } else {
                script.src = `https://playerservices.live.streamtheworld.com/api/idsync.js?stationId=${triton}&gdpr=0`
            }
        });
    });
    return {
        triton,
        gdpr: hasGdrp
    }
}